export default "__VITE_ASSET__486d81d2__"